import React from 'react';
// import { translate } from '../utils/useful'
// import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import Loader from 'react-loader-spinner';
import HttpServices from '../utils/Http.services';
import HubNotFound from './Hub/HubNotFound';
import HubMain from './Hub/HubMain';
import { imageAddress } from '../utils/useful';
import store from '../stores/storeConfig';




class Hub extends React.Component {

    state = {
        // pageStatus: 0,
        path: [],
        pages: []
    }

    componentDidMount() {
        // this.initPageSetup()
        this.initPage()
        // this.getHubs()
    }
    // getHubs = () => {
    //     console.log('here')
    //     HttpServices.request('getHubs', {}, (fetchResult, fetchError) => {
    //         if (fetchError) {
    //             return
    //         }
    //         console.log('get hubs')
    //         this.setState({ hub: fetchResult.info }, () => {
    //             this.setState({ isLoadingPage: false })
    //         })
    //     })
    // }
    componentDidUpdate(prevProps) {


    }

    initPage() {

        // console.log(this.props.data)
        let username
        let slug

        if (this.props.data?.params?.username) {
            username = this.props.data?.params?.username
        }

        if (this.props.data?.params?.slug) {
            slug = this.props.data?.params?.slug
        }


        if (this.props.data?.path && this.props.data?.path[0]) {
            username = this.props.data?.path[0]
            slug = this.props.data?.path[1]

            if (username == 'p') {
                username = this.props.data?.path[1]
                slug = this.props.data?.path[2]

            }
        }


        // let slug = this.props.data?.path[2]

        // return




        // if (path[0] == 'p' || (path[0] != this.state.path[1] && (!this.state.path[1] || path[1] != this.state.path[1]))) {
        //     this.setState({ applet: {}, user: {}, pageError: null, appletType: null, pageTitle: '', pageSubTitle: '', path: [] }, () => {
        // console.log(this.props.data?.path)
        // console.log(slug)

        if (slug) {
            // let path = [username, slug]
            // let pathAppend = this.props.data?.paths
            // if (pathAppend) {
            //     pathAppend.splice(0, 2)
            //     path = [...path, ...pathAppend]
            // }
            // console.log(path)
            // console.log(pathAppend)
            this.props.changeWindow('applet', { path: this.props.data?.path })
            return
        }

        if (username) {
            this.fetchHub(username)
            this.setState({ initData: this.props.data })
        }

        // })
        // }
    }
    fetchPage = (user) => {
        // console.log('useruseruseruser', user)
        HttpServices.request('getFrames', { type: 'page', mode: 'user', hub: user }, (fetchResult, fetchError, fetchStatus) => {
            if (fetchError) {
                return
            }
            this.setState({ pages: fetchResult.info })
        })
    }


    fetchHub(username) {
        this.setState({ isLoadingPage: true })

        // if (path[0] == "p") {
        //     path.splice(0, 1)
        // }
        // console.log(path)
        HttpServices.request('getHubByUsername', { username: username }, (fetchResult, fetchError, fetchStatus) => {
            // console.log('fetchResultssadad', fetchResult)
            store.dispatch(actions.updateUsedRelation([fetchResult.relation]))
            // console.log(fetchResult)
            this.setState({ isLoadingPage: false }, () => {
                if (fetchError) {
                    // this.setPageError(fetchError, path)
                    return
                }

                // if (fetchResult && fetchResult.user) {
                // console.log('userfetchResult', fetchResult)
                // console.log(fetchStatus)
                this.fetchPage(fetchResult.user._id)

                this.setPageView(fetchResult)
                // { console.log('fetchResultpp', fetchResult) }
            })
            // }

        })
    }


    setPageView(data) {


        if (Array.isArray(data.applets)) {
            for (let a = 0; a < data.applets.length; a++) {
                let applet = data.applets[a];

                if (Array.isArray(applet.connections)) {

                    for (let c = 0; c < applet.connections.length; c++) {
                        const connection = applet.connections[c];
                        if (applet.status != 'C') {
                            applet.status = connection.status
                        }
                        if (connection.isPublic) {
                            applet.public = true
                        }

                        if (connection.adminAccess) {
                            applet.adminAccess = true
                        }
                    }
                }

            }
        }

        // console.log(data.applets)

        this.props.setWindowInfo({ title: data.user?.fullname, icon: imageAddress(data.user?.image, 'profile', 'mini') })
        setTimeout(() => {
            this.setWindowButtons(false) 
        }, 50);

        this.setState({ relation: data.relation, connection: data.connection, applets: data.applets, applet: data.applet, hub: data.user })
        let pageTitle = ''
        let appletType = 'Main'
        let pageSubTitle = null
        // console.log('setPageView', data)

        if (!data.applet) {

            // if (!path[1] || path[1] == '') {
            // this.setState({ appletType: 'Main' })
            pageTitle = data.user.fullname
            // } else {
            //   this.setState({ pageError: -2 })
            // }

        } else {
            appletType = data.applet.type
            pageTitle = data.applet.name
            pageSubTitle = data.user.fullname
            // { console.log('pageTitle', pageTitle) }

        }


        this.setState({ appletType, pageTitle, pageSubTitle, connectionTypes: data.connectionTypes })

    }


    setWindowButtons = (canSwitch) => {

        // console.log("setWindowButtons")
        let buttons = []
        if (canSwitch) {
            buttons.push({ name: 'switchView', icon: '/assets/icons/useful/switchView1.png' })
        }

    // console.log('setWindowButtons', buttons, this.props.setWindowButtons)
        this.props.setWindowButtons(buttons)
    }


    goToApplet = (applet, full) => {
        let path = [this.state.hub?.username, applet.slug]
        if (full.adminAccess) {
            path.push('admin')
        }

        this.props.changeWindow('applet', { path: path })
    }

    setRelation = (relation) => {
        // console.log("relation", relation)
        this.setState({ relation })
    }

    render() {
        return (
            <div className="w-100 d-flex hub back-blur h-100 window-content-radius"  >
                <div className=' w-100  h-100 bg-white window-content-radius'>
                    {this.state.isLoadingPage && (
                        <div className="text-center w-100" style={{ paddingTop: '10vh' }}>
                            <Loader
                                type="Oval"
                                color="#789"
                                height="50"
                                width="50"
                            />
                        </div>
                    )}
                    {this.state.hub && !this.state.isLoadingPage && (
                        <HubMain pages={this.state.pages} mainColor={this.props.mainColor} language={this.props.settings.language} width={this.props.width} hub={this.state.hub} applets={this.state.applets} connectionTypes={this.state.connectionTypes} goToApplet={this.goToApplet} relation={this.state.relation} addNewWindow={this.props.addNewWindow} setRelation={this.setRelation} />
                    )}
                    {!this.state.hub && !this.state.isLoadingPage && (
                        <div className=" px-3 flex-column">
                            <HubNotFound />
                        </div>
                    )}
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Hub);